/** Polling interval (ms) for desktop-agent offline/download status while remote grant is enabled. */
export const FILES_OFFLINE_POLL_MS = 30_000;
